export default __webpack_public_path__ + "static/media/icons8-remove-48.6cd52d54.svg";